import { render, staticRenderFns } from "./iosbuy.vue?vue&type=template&id=8f959034&scoped=true"
import script from "./iosbuy.vue?vue&type=script&lang=js"
export * from "./iosbuy.vue?vue&type=script&lang=js"
import style0 from "./iosbuy.vue?vue&type=style&index=0&id=8f959034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f959034",
  null
  
)

export default component.exports